module.exports = __webpack_public_path__ + "static/media/Avatars_Male-06.2aae6806.png";